import React, { useContext } from "react";
import themeContext from "../../../../context/theme/ThemeContext";

const MailIcon = () => {
  const { getThemeColor } = useContext(themeContext);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5 4.5C16.5 3.675 15.825 3 15 3H3C2.175 3 1.5 3.675 1.5 4.5V13.5C1.5 14.325 2.175 15 3 15H15C15.825 15 16.5 14.325 16.5 13.5V4.5ZM15 4.5L9 8.2425L3 4.5H15ZM9 9.75L3 6V13.5H15V6L9 9.75Z"
        fill={getThemeColor("icon-color")}
      />
    </svg>
  );
};

export default MailIcon;
